<template>
    <b-alert
        show
        variant="danger"
        class="mt-3 addon-disabled"
        style="display: flex; align-items: center;"
    >
        <div style="flex: 1;">
            The boarding extension is currently not enabled.<br />If you wish to
            use the boarding feature, you can enable it by navigating to
            Settings > Add-ons > Boarding.
        </div>
        <a
            :href="env.APPS + 'business/business?extension'"
            @click.prevent="goToSettings"
            style="margin-right: 15px;"
        >
            Go to Settings
        </a>
        <router-link :to="{ name: 'appointment' }">Enable later</router-link>
    </b-alert>
</template>

<script>
export default {
    methods: {
        goToSettings() {
            localStorage.setItem("prev_sub", "extension");
            window.location.href = process.env.APPS + "business/business";
        }
    }
};
</script>
